<template>
    <div class="container text-center">
        <img :src="`/img/be/${this.targa}/logo.svg`" class="img-fluid"
             @error="fallbackImage">
    </div>
</template>

<script>
    export default {
        props: ['targa'],
        methods: {
            fallbackImage: function (e) {
                e.target.src = '/img/be/' + this.targa + '/logo.png';
            }
        }
    }
</script>
